import { render } from "./BarcodeRowImage.vue?vue&type=template&id=89e8aa4e&scoped=true"
import script from "./BarcodeRowImage.vue?vue&type=script&lang=ts"
export * from "./BarcodeRowImage.vue?vue&type=script&lang=ts"

import "./BarcodeRowImage.vue?vue&type=style&index=0&id=89e8aa4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-89e8aa4e"

export default script